import { Box, Grid, Typography, useTheme } from "@mui/material";

import React from "react";
import Boxoutline from "../../../../../media/images/icons/outline-box";
import CustomBadge from "../../../../components/CustomBadge";

export default function NotifCard() {
  const theme = useTheme();

  return (
    <Grid
      container
      sx={{
        // border: "1px solid gray",
        paddingX: "4px",
        borderRadius: "8px",
        boxShadow: "2px 4px 4px 2px rgba(0, 0, 0, 0.10)",
      }}
      spacing={1}
    >
      <Grid
        item
        sx={{
          padding: "4px",
        }}
        xs={2}
      >
        <Box
          sx={{
            borderRadius: "8px",
            // border: "1px solid gray",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "primary.light",
            paddingY: "30px",
          }}
        >
          <Boxoutline color={theme.palette.primary.main} />
        </Box>
      </Grid>
      <Grid item xs={10}>
        <Box
          sx={{
            // border: "1px solid gray",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              اطلاعات حساب کاربری کامل شد.
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              اطلاعات حساب کاربری کامل شد.
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <CustomBadge size="small" status="inprogress" text="بارها" />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
